<template>
  <div class="summary-style">
    <div class="select-wrap">
      <div>
        <el-date-picker
          v-model="time"
          :clearable="false"
          unlink-panels
          type="daterange"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="handleRangePickerChange"
          size="small">
        </el-date-picker>
      </div>

      <div>
          <el-button type="primary" @click="getData" size="small">查询</el-button>
      </div>
    </div>
    <div class="card-wrap">
      <div>
        <div class="card-title">发货总金额</div>
        <div class="card-content big-num">￥{{deliverInfo.total_amount?deliverInfo.total_amount:0}}</div>
      </div>
      <div>
        <div class="card-title">结算总金额</div>
        <div class="card-content"></div>
        <div class="card-footer">已支付金额：<span class="card-footer-money">¥{{settleInfo.payedAmount?settleInfo.payedAmount:0}}</span></div>
        <div class="card-footer">未支付金额：<span class="card-footer-money">¥{{settleInfo.unpaidAmount?settleInfo.unpaidAmount:0}}</span></div>
      </div>
      <div>
        <div class="card-title">退货总金额</div>
        <div class="card-content"></div>
<!--        <div class="card-content">-￥{{refundInfo.refundTotalAmount?refundInfo.refundTotalAmount:0}}</div>-->
        <div class="card-footer">已扣款金额：<span class="card-footer-money">¥{{refundInfo.deductedAmount?refundInfo.deductedAmount:0}}</span></div>
        <div class="card-footer">未扣款金额：<span class="card-footer-money">¥{{refundInfo.unSettledAmount?refundInfo.unSettledAmount:0}}</span></div>
      </div>
    </div>
    <div class="summary-report-wrap">
      <div class="tabs">
        <span class="tab" :class="{'active-tab': activeTab === 1}" @click="goToBillList(1)">发货列表</span>
        <span class="tab" :class="{'active-tab': activeTab === 2}" @click="goToBillList(2)">结算列表</span>
        <span class="tab" :class="{'active-tab': activeTab === 3}" @click="goToBillList(3)">退货列表</span>
      </div>
      <!-- 发货列表-->
      <deliver-goods-list v-show="activeTab === 1" ref="deliverChild"/>
      <!-- 结算列表-->
      <settle-list v-show="activeTab === 2" ref="settleChild"/>
      <!-- 退货列表-->
      <return-goods-list v-show="activeTab === 3" ref="returnChild"/>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import {querySettleSumInfo, queryRefundSumInfo, queryDeliverGoodsTotalAmount} from '@/models/r4ReportModel'
import DeliverGoodsList from './components/deliverGoodsList';
import SettleList from "./components/settleList";
import ReturnGoodsList from "./components/returnGoodsList";
const isType = type => target => `[object ${type}]` === Object.prototype.toString.call(target)
const isNumber = isType('Number')
const plainOptions = [
  {
    label: '全部',
    value: ''
  },
  {
    label: '发货',
    value: 1
  },
  {
    label: '退款',
    value: 2
  },
  {
    label: '实结',
    value: 3
  },
  {
    label: '未结',
    value: 4
  }
]

export default {
  props: ['type'],
  data () {
    return {
      activeTab: 1,
      deliverActiveTab: 1,
      loading: false,
      expandLoading: false,
      plainOptions: plainOptions,
      search: '',
      checkedList: [],
      tableData: [],
      time: [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      dialogData: {},
      totalData: {},
      page: 1,
      pageSize: 10,
      totalCount: 0,
      pickerOptions: {
        // disabledDate (current) {
        //   return current && (current > moment().endOf('day') || current < moment().subtract(3, 'months'))
        // }
      },
      settleInfo: {
        payedAmount: '',
        unpaidAmount: ''
      },
      refundInfo: {
        deductedAmount: '',
        refundTotalAmount: '',
        unSettledAmount: ''
      },
      deliverInfo: {
        total_amount: ''
      }
    }
  },
  filters: {
    fixedNumber (val) {
      let value = Number(val)
      return isNaN(isNumber(value)) ? '' : parseFloat(value)
    }
  },
  methods: {
    goToBillList(type) {
      console.log(type, "type");
      this.activeTab = type;
      switch (type) {
        case 1:
          this.$refs.deliverChild.loadDeliverGoodsList(1);
          break;
        case 2:
          this.$refs.settleChild.loadPayedSettle();
          break;
        case 3:
          this.$refs.returnChild.loadRedBlueOffset();
          this.$refs.returnChild.loadDeductedRefund();
          break;
      }
    },
    moment,
    filterType (type, orderStatus, status) {
      let str = {
        status: '',
        reason: ''
      }
      if (type === '2') {
        str.status = '售后退货'
        str.reason = '售后退货'
      }
      if (type === '1' && status === '已付款') {
        str.status = '已付款'
        str.reason = '已付款'
      }
      if (type === '1' && status !== '已付款') {
        str.status = '未结账'
        if (orderStatus === '已完成') {
          str.reason = '未到结账周期'
        }
        if (orderStatus && orderStatus !== '已完成') {
          str.reason = '商城订单未完成'
        }
        if (!orderStatus) {
          str.reason = '未生成应付单'
        }
      }

      return str
    },
    getData () {
      this.getTotalData()
    },
    handleRangePickerChange(value) {
      console.log(value, "value", moment(value[1]).subtract(3, "months").isBefore(moment(value[0])));
      if (!moment(value[1]).subtract(3, "months").isBefore(moment(value[0]))) {
        this.$message.error("选择的时间跨度最大为3个月");
        this.time = [moment(value[1]).subtract(3, "months").format('YYYY-MM-DD'), moment(value[1]).format('YYYY-MM-DD')];
      } else {
        this.time = value;
      }
    },

    // 获取发货退货结算
    getTotalData () {
      this.loadDeliverGoodsTotalAmount();
      this.loadSettle();
      this.loadRefund();
    },
    // 获取发货总金额
    loadDeliverGoodsTotalAmount() {
      queryDeliverGoodsTotalAmount({
        shop_id: localStorage.getItem('shop_id'),
        start_time: this.time[0] + ' 00:00:00',
        end_time: this.time[1] + ' 23:59:59'
      }).then(res => {
        this.deliverInfo = res
      }).catch((err) => {
        console.log(err);
        this.$message.error(err.message);
      });
    },
    // 获取结算汇总金额
    loadSettle() {
      querySettleSumInfo({
        supplierId: localStorage.getItem('supplier_id'),
        startDate: this.time[0] + ' 00:00:00',
        endDate: this.time[1] + ' 23:59:59'
      }).then(res => {
        this.settleInfo = res
      }).catch((err) => {
        console.log(err);
        this.$message.error(err.message);
      });
    },
    // 获取退款金额汇总
    loadRefund() {
      queryRefundSumInfo({
        supplierId: localStorage.getItem('supplier_id'),
        startDate: this.time[0] + ' 00:00:00',
        endDate: this.time[1] + ' 23:59:59'
      }).then(res => {
        this.refundInfo = res
      }).catch((err) => {
        console.log(err);
        this.$message.error(err.message);
      });
    },
  },
  created () {
    this.getTotalData();
  },
  components: {
    DeliverGoodsList,
    SettleList,
    ReturnGoodsList
  }
}
</script>

<style lang="scss" scoped>
.summary-style {
  .btn {
    width: 70px;
    height: 30px;
    background: linear-gradient(132deg, #FF602F 0%, #FF3722 100%, #FF3621 100%, #FF3621 100%, #FF3722 100%);
    border-radius: 6px;
    font-size: 8px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    padding: 0;
    line-height: 30px;
    margin-top: 5px;
  }

  .default-btn {
    background: #fff;
    font-size: 8px;
    font-family: MicrosoftYaHei;
    color: #666666;
    border-radius: 6px;
    border: 1px solid #D5D5D5;
  }
}

  .select-wrap {
      display: flex;
      align-items: center;
      margin: 20px 0;
  }

  .select-wrap > div {
      padding-right: 20px;
  }

  .checkbox {
      margin-right: auto;
      margin-left: 15px;
  }
  .card-wrap{
    display: flex;
    margin-bottom: 20px;
    & > div{
      box-sizing: border-box;
      min-width:210px;
      height:135px;
      border-radius:9px;
      margin-right: 20px;
      padding:18px;
      color: #fff;
    }
    & > div:nth-child(1){
      background: linear-gradient(135deg, #FFAA2D 0%, #FE652B 100%);
      box-shadow: 0px 2px 4px 0px rgba(0, 18, 157, 0.05);
      background-size:cover ;
      position: relative;
      .big-num {
        font-size: 28px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #FFFFFF;
        position: absolute;
        bottom: 8px;
        right: 8px;
      }
    }
    & > div:nth-child(2){
      background: linear-gradient(134deg, #68CCFF 0%, #4E99F4 100%);
      background-size:cover ;
      box-shadow: 0px 6px 9px 0px rgba(91, 179, 250, 0.43);
    }
    & > div:nth-child(3){
      background: linear-gradient(136deg, #FFD75C 0%, #FF9F3F 100%);
      background-size:cover ;
      box-shadow: 0px 6px 9px 0px rgba(255, 175, 71, 0.44);
    }
    .card-title{
      font-size: 14px;
      margin-bottom: 5px;
    }
    .card-content{
      font-size: 28px;
      font-weight: 500;
      height: 40px;
      &-money{
        font-size: 15px;
      }
    }
    .card-footer{
      font-size: 14px;
      position: relative;
      &-money{
        font-size: 18px;
        position: absolute;
        right: 0;
      }
    }
    .card-img{

    }
  }
  .dialog-content{
    display: flex;
    // justify-content: space-around;
    text-align: left;
    > div{
      margin-left: 30px;
      min-width: 400px;
      padding:10px;
    }
  }
  .tabs {
    margin-top: 6px;
    >span:first-child {
      border-radius: 4px 0px 0px 0px;
    }
    > span:nth-child(2) {
      margin-left: -5px;
    }
    > span:last-child {
      border-radius: 0px 4px 0px 0px;
      margin-left: -5px;
    }
  }
  .tab {
    width: 60px;
    height: 22px;
    background: #73818C;
    color: #fff;
    padding: 6px 18px;
    cursor: pointer;
  }
  .active-tab {
    background: #A4B4C1;
  }
.el-icon-date:before {
  position: absolute;
  top:0 !important;
}
</style>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/r4SettlementReport/summaryReport/summaryReport.vue